import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=3ab54866&"
var script = {}
import style0 from "./brief.vue?vue&type=style&index=0&id=3ab54866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports